import React from "react";
// import { IoMdEyeOff } from "react-icons/io";
// import { IoEye } from "react-icons/io5";
import { Link } from "react-router-dom";
import PaginationModified from "../../data/PaginationModified";

const AgreementReportMobile = ({
  tableData,
  isPage,
  setIsPage,
  setPageLimit,
  pageLimit,
  tablePagination,
  showPassword,
  handleEyeOtp,
}) => {
  function getPagination() {
    try {
      const pagination = tablePagination ? tablePagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="all-leads-log mt30">
      {tableData?.length > 0 &&
        tableData.map((row, index) => {
          return (
            <div className="log-card" key={index}>
              <div className="all-info-agent">
                <div className="label-value-agent flexCol">
                  <span className="label">Gym Name</span>
                  <span className="value">{row?.gym_name || "NA"}</span>
                </div>
                <div className="label-value-agent flexCol">
                  <span className="label">Name</span>
                  <span className="value">{row?.name || "NA"}</span>
                </div>
                <div className="label-value-agent flexCol">
                  <span className="label">Mobile </span>
                  <span className="value">{row?.mobile || "NA"}</span>
                </div>
                <div className="label-value-agent flexCol">
                  <span className="label">Status</span>
                  <p className="tb-data minWidth90 table__Text">
                    {row?.is_accepted === 0 ? (
                      <span className="agreement__Pending">pending</span>
                    ) : (
                      <span className="agreement__Accepted">accepted</span>
                    )}
                  </p>
                </div>
                <div className="label-value-agent flexCol">
                  <span className="label">Plan Name</span>
                  <span className="value">{row?.plan_name || "NA"}</span>
                </div>

                <div className="label-value-agent flexCol">
                  <span className="label">Verification Code </span>
                  <div className="agreement__Otp">
                    <p>
                      {row?.otp
                        ? showPassword.includes(row?.uid)
                          ? row?.otp
                          : "********"
                        : "NA"}
                    </p>
                    <p
                      onClick={() => handleEyeOtp(row?.uid)}
                      className="agreement__EyeIcon"
                    >
                      {showPassword.includes(row?.uid) ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-eye-slash-fill"
                          viewBox="0 0 16 16"
                        >
                          <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z" />
                          <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z" />
                        </svg>
                      ) : (
                        // <IoMdEyeOff size={26} />
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-eye-fill"
                          viewBox="0 0 16 16"
                        >
                          <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                          <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
                        </svg>
                        // <IoEye size={26} />
                      )}{" "}
                    </p>
                  </div>
                </div>

                <div className="label-value-agent flexCol">
                  <span className="label">Agreement URL</span>
                  <span className="value agreementMobileUrl">
                    {row?.agreement_url ? (
                      <Link target="_blank" to={row?.agreement_url}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-box-arrow-up-right"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fillRule="evenodd"
                            d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"
                          />
                          <path
                            fillRule="evenodd"
                            d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
                          />
                        </svg>
                      </Link>
                    ) : (
                      "NA"
                    )}
                  </span>
                </div>
              </div>
            </div>
          );
        })}

      <div className="lead-logs-card-pagination">
        <PaginationModified
          isPage={isPage}
          onChangePage={setIsPage}
          pagination={getPagination()}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      </div>
    </div>
  );
};

export default AgreementReportMobile;
